import "../shared/sparkle_namespace.js";

window.Sparkle ??= {};

Sparkle.Physicians = Sparkle.Physicians || {};
